
let Constants = {
  // 进出口类型参数
  IMEX: [{label: '出口', value: 'EX'}, {label: '进口', value: 'IM'}],

  // 室内外库
  StorageInOut: [{label: '室内库', value: 1}, {label: '室外库', value: 2}, {label: '都可以', value: 0}],

  uploadAction: process.env.SSO_API_URL + '/api/upload/uploadtempfile',

  uploadHeaders: {},

  managerList: [{key: '13771712871', value: '戴巧莲'},
    {key: '13913508929', value: '夏保玲'},
    {key: '13814850164', value: '王浩钟'},
    {key: '18912476535', value: '姚之润'},
    {key: '13914018728', value: '刘宏伟'},
    {key: '18012352101', value: '娄玉洁'},
    {key: '15366200400', value: '徐小东'},
    {key: '13621489423', value: '周耿心'},
    {key: '13812293008', value: '周红'},
    {key: '15861588106', value: '周雪洁'},
    {key: '17351327627', value: '陈晓天'},
    {key: '15962427396', value: '刘坤'},
    {key: '13776058541', value: '郭敏'}]
}

export {
  Constants
}



// WEBPACK FOOTER //
// ./src/assets/js/constants.js